// eslint-disable-next-line import/prefer-default-export
export const MODES = {
  VIEW: 'view',
  SELECT: 'select',
  DELETE: 'delete',
};
